<div class="run-changesets">
    <div class="run-changeset">
        <strong class="num">{{this.commitCount}}</strong>
        <span class="changes commitLabel">commit{{#ifCond this.commitCount '>' 1}}s{{/ifCond}}</span>
    </div>
</div>